import { CircularProgress } from '@mui/material';

import { goPalette } from '../../../material-ui-theme/tsGoThemeVars';
import usePortal from '../../../utils/usePortal';
import { useZustand } from '../../../zustandStore';

import type { FC, PropsWithChildren } from 'react';

type PageSpinnerProps = {
	isLoading?: boolean | number;
};

const PageSpinner: FC<PropsWithChildren<PageSpinnerProps>> = ({ isLoading = false }) => {
	const spinner = (
		<div
			data-testid="page-spinner"
			style={{
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				backgroundColor: 'rgba(0,0,0,.71)',
				color: goPalette.tsGoColor.white,
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				zIndex: 1000,
			}}
		>
			<CircularProgress color="inherit" />
		</div>
	);

	const isPageLoading = useZustand(state => state.pageSpinner.isLoading);
	const portalContent = usePortal('go-app-container', spinner);

	return Boolean(isLoading) || isPageLoading ? portalContent : null;
};

export default PageSpinner;
